export default __webpack_public_path__ + "static/media/8_icg_front_hotel.520e0ac3.svg";